import React from 'react';
import { ClassNameMap } from '@material-ui/styles';
import { MenuItem, Select } from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { SelectItem } from '../types/locationTypes'

interface BillingTypeSelectProps {
    parentClasses: ClassNameMap,
    setBillingType: any,
    billingType: string,
    billingTypes: SelectItem[],
    disabled: boolean
}

const BillingTypeSelect: React.FC<BillingTypeSelectProps> = ({
    parentClasses,
    setBillingType,
    billingType,
    billingTypes,
    disabled
}) => {
    return (
        <>
            <div className={parentClasses.textFieldLable}>BILLING MODEL</div>
            <Select
                onChange={e => setBillingType(e.target.value)}
                className={parentClasses.selectField}
                style={{ borderRadius: 0 }}
                fullWidth={true}
                value={billingType}
                IconComponent={KeyboardArrowDownIcon}
                disabled={disabled}
                displayEmpty
                defaultValue='0'
                variant="outlined"
            >
                {billingTypes.map((item) => (
                    <MenuItem
                        disabled={item.disabled}
                        selected={item.selected}
                        key={item.value}
                        defaultValue={item.value}
                        value={item.value}
                    >
                        {item.text}
                    </MenuItem>
                ))}            
            </Select>
        </>
    );
}

export default BillingTypeSelect;